import { useEffect } from "react";

const title = "Dmitry Kordik | Full Stack / Mobile Software Developer | Toronto";
const description = "Toronto-based full-stack and mobile developer shipping production web and mobile applications end-to-end. Explore TONearby, professional experience, and skills.";

// Mounted only on the portfolio; protected route metadata remains owned by those pages.
export default function HomepageMetadata() {
  useEffect(() => {
    const previousTitle = document.title;
    const cleanups = [];
    const setHeadElement = (selector, tag, attributes) => {
      const existing = document.head.querySelector(selector);
      const element = existing || document.createElement(tag);
      const originalAttributes = existing ? Array.from(existing.attributes).map(({ name, value }) => [name, value]) : [];
      Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
      if (!existing) document.head.appendChild(element);
      cleanups.push(() => {
        if (!existing) element.remove();
        else {
          Array.from(element.attributes).forEach(({ name }) => element.removeAttribute(name));
          originalAttributes.forEach(([key, value]) => element.setAttribute(key, value));
        }
      });
    };
    document.title = title;
    setHeadElement('meta[name="description"]', "meta", { name: "description", content: description });
    setHeadElement('link[rel="canonical"]', "link", { rel: "canonical", href: "https://kordik.ca/" });
    Object.entries({ "og:title": title, "og:description": description, "og:type": "website", "og:url": "https://kordik.ca/", "og:image": "https://kordik.ca/logo.png" }).forEach(([property, content]) => {
      setHeadElement(`meta[property="${property}"]`, "meta", { property, content });
    });
    const structuredData = document.createElement("script");
    structuredData.type = "application/ld+json";
    structuredData.textContent = JSON.stringify({
      "@context": "https://schema.org", "@type": "Person",
      name: "Dmitry Kordik", url: "https://kordik.ca/",
      jobTitle: "Full Stack / Mobile Software Developer",
      homeLocation: { "@type": "Place", name: "Toronto, Canada" },
      sameAs: ["https://www.linkedin.com/in/dmitry-kordik-b8410b19a/"]
    });
    document.head.appendChild(structuredData);
    return () => {
      document.title = previousTitle;
      cleanups.reverse().forEach(cleanup => cleanup());
      structuredData.remove();
    };
  }, []);
  return null;
}
